import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";

function ModalForm({
  title,
  isOpen,
  onClose,
  onSubmit,
  textBtn,
  children,
  showSubtitle = true,
}) {
  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="poppins-medium fixed z-50 inset-0 overflow-y-auto"
        onClose={onClose}
      >
        <div className="flex items-center justify-center min-h-screen px-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-30 transition-opacity" />
          </Transition.Child>

          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="flex flex-col justify-center relative bg-white rounded-lg px-12 py-14 overflow-hidden shadow-xl transform transition-all md:w-[45%] w-full p-6">
              {/* Botón de cierre en la esquina superior derecha */}
              <button
                onClick={onClose}
                className="absolute top-5 right-9 text-[#000000] hover:text-gray-600 focus:outline-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="currentColor"
                  className="w-8 h-8"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>

              <Dialog.Title
                as="h3"
                className="text-lg leading-6 text-[#1F384C] tracking-wider"
              >
                {title}
              </Dialog.Title>
              {showSubtitle && (
                <p className="poppins-regular mt-3 text-xs text-[#8F99A6] tracking-wider">
                  Completa los campos con todos los datos
                </p>
              )}

              {/* Formulario */}
              <div className="mt-7 space-y-6">
                {/* Aquí estamos usando los campos pasados como children */}
                {children}
              </div>

              {/* Botón para enviar el formulario */}
              <div className="flex justify-end">
                <button
                  className="w-full flex justify-center mt-10 py-3 px-5 border rounded-2xl shadow-sm text-sm text-white bg-[#BE202F] tracking-wider"
                  onClick={onSubmit}
                >
                  {textBtn}
                </button>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default ModalForm;
